var map = {
	"./Kendra": 8809,
	"./Kendra.ts": 8809,
	"./constants": 13158,
	"./constants.ts": 13158,
	"./helpers/LocalCredentialsBanner": 12228,
	"./helpers/LocalCredentialsBanner.tsx": 12228,
	"./helpers/MockDataWarning": 55766,
	"./helpers/MockDataWarning.tsx": 55766,
	"./local-dev-credentials-template": 4994,
	"./local-dev-credentials-template.json": 4994
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31674;